import React from 'react';

import CaseStudiesLandingHelmet from 'common/helmets/CaseStudiesLandingHelmet';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import UppercaseHeader from 'common/UppercaseHeader';
import AgencyAnalyticsWordmark from 'img/landing/agencyanalytics-wordmark.webp';
import AhrefsWordmark from 'img/landing/ahrefs-wordmark.webp';
import AndreaPark from 'img/landing/andrea-park.webp';
import AxiosWordmark from 'img/landing/axios-wordmark.webp';
import CCIWordmark from 'img/landing/cci-wordmark.webp';
import Chelsea from 'img/landing/chelsea.webp';
import ClickupWordmark from 'img/landing/clickup-wordmark.webp';
import Document360Wordmark from 'img/landing/document360-wordmark.webp';
import FiguredWordmark from 'img/landing/figured-wordmark.webp';
import GiveButterWordmark from 'img/landing/givebutter-wordmark.webp';
import HiveWordmark from 'img/landing/hive-wordmark.webp';
import Ida from 'img/landing/ida.webp';
import JaneTechnologiesWordmark from 'img/landing/janetechnologies-wordmark.webp';
import KelleyMichaela from 'img/landing/kelley-and-michaela.webp';
import KnakWordmark from 'img/landing/knak-wordmark.webp';
import LylaJoey from 'img/landing/lyla-and-joey.webp';
import MercuryWordmark from 'img/landing/mercury-wordmark.webp';
import MissiveWordmark from 'img/landing/missive-wordmark.webp';
import PallyyWordmark from 'img/landing/pallyy-wordmark.webp';
import StickerMuleWordmark from 'img/landing/stickermule-wordmark.webp';
import StrapiWordmark from 'img/landing/strapi-wordmark.webp';
import Tim from 'img/landing/tim.webp';

import AkiflowWordmark from 'img/landing/akiflow-wordmark.svg';
import AppcuesWordmark from 'img/landing/appcues-wordmark.svg';
import GetimgAIWordmark from 'img/landing/getimg-wordmark.svg';
import OutlierWordmark from 'img/landing/outlier-wordmark.svg';
import SpekitWordmark from 'img/landing/spekit-wordmark.svg';
import TLDVWordmark from 'img/landing/tldv-wordmark.svg';

import 'css/components/case-studies/_CaseStudiesLanding.scss';

const CaseStudiesLanding = () => {
  return (
    <div className="caseStudiesLanding">
      <CaseStudiesLandingHelmet />
      <div className="caseStudiesLandingContainer">
        <div className="header">
          <div className="left">
            <div className="text">
              <h1 className="title">
                <span className="bold">Thousands</span> of software teams{' '}
                <span className="bold">trust&nbsp;Canny</span> to inform their
                product&nbsp;decisions
              </h1>
            </div>
          </div>
        </div>
        <div className="customerGrid">
          <Link className="customerItem" to="/case-studies/ahrefs">
            <div className="customerItemContents ahrefs">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage loading="eager" src={AhrefsWordmark} alt="Ahrefs logo" />
                </div>
                <p className="description">
                  How Ahrefs uses Canny to track feature requests and set
                  customer&nbsp;expectations.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem double mercury" to="/case-studies/mercury">
            <div className="customerItemContents mercury">
              <div className="text">
                <div className="top">
                  <div className="wordmark">
                    <LazyLoadedImage loading="eager" src={MercuryWordmark} alt="Mercury logo" />
                  </div>
                  <p className="description">
                    How Mercury found a drastic improvement in efficiency and&nbsp;productivity
                  </p>
                </div>
                <UppercaseHeader>
                  Read their story <span className="icon-chevron-right" />
                </UppercaseHeader>
              </div>
              <LazyLoadedImage className="profile" loading="eager" src={Ida} alt="Ida Ström" />
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/circleci">
            <div className="customerItemContents cci">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage loading="eager" src={CCIWordmark} alt="CircleCI logo" />
                </div>
                <p className="description">
                  How CircleCI uses Canny as their home for feedback to inform their
                  product&nbsp;decisions.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/clickup">
            <div className="customerItemContents clickup">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage loading="eager" src={ClickupWordmark} alt="ClickUp logo" />
                </div>
                <p className="description">
                  How ClickUp uses Canny to keep track of feedback from a rapidly growing
                  user&nbsp;base.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/axios">
            <div className="customerItemContents axios">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage loading="eager" src={AxiosWordmark} alt="Axios logo" />
                </div>
                <p className="description">
                  How Axios uses Canny to align internal teams, inform stakeholders, and reduce time
                  spent on messy&nbsp;communications.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem double" to="/case-studies/ahrefs">
            <div className="quote">
              <div className="text">
                "I know if we stopped using Canny today, tracking feature requests would be
                a&nbsp;disaster."
                <div className="credit">Tim Soulo, CMO at&nbsp;Ahrefs</div>
              </div>
              <LazyLoadedImage className="quoteImage" loading="eager" src={Tim} alt="Tim Soulo" />
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/stickermule">
            <div className="customerItemContents stickerMule">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage
                    loading="eager"
                    src={StickerMuleWordmark}
                    alt="Sticker Mule logo"
                  />
                </div>
                <p className="description">How Sticker Mule uses Canny to reveal big&nbsp;wins.</p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/figured">
            <div className="customerItemContents figured">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage src={FiguredWordmark} alt="Figured logo" />
                </div>
                <p className="description">
                  How Figured uses Canny to strengthen team collaboration and build&nbsp;community.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/agencyanalytics">
            <div className="customerItemContents agencyanalytics">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage src={AgencyAnalyticsWordmark} alt="AgencyAnalytics logo" />
                </div>
                <p className="description">
                  How AgencyAnalytics uses Canny to earn more revenue and avoid&nbsp;churn.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/strapi">
            <div className="customerItemContents strapi">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage src={StrapiWordmark} alt="Strapi logo" />
                </div>
                <p className="description">
                  How Strapi uses Canny to interact with their community and close more&nbsp;deals.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/knak">
            <div className="customerItemContents knak">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage src={KnakWordmark} alt="Sticker Mule logo" />
                </div>
                <p className="description">
                  How Knak's customer success team uses Canny to streamline feedback&nbsp;processes.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem double aryeo" to="/case-studies/aryeo">
            <div className="quote">
              <div className="text">
                "Canny has reduced the number of inbounds in our support inbox by 20%, which is
                a&nbsp;big&nbsp;deal."
                <div className="credit">Chelsea Darby, Customer Success Lead at&nbsp;Aryeo</div>
              </div>
              <LazyLoadedImage className="quoteImage chelsea" src={Chelsea} alt="Chelsea Darby" />
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/missive">
            <div className="customerItemContents missive">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage src={MissiveWordmark} alt="Missive logo" />
                </div>
                <p className="description">
                  How Missive uses Canny to cut down on support time and prioritize
                  new&nbsp;features.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/janetechnologies">
            <div className="customerItemContents janeTechnologies">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage
                    src={JaneTechnologiesWordmark}
                    alt="Jane Technologies case study"
                  />
                </div>
                <p className="description">
                  How Jane Technologies streamlined user feedback and boosted company&nbsp;culture.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/givebutter">
            <div className="customerItemContents givebutter">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage src={GiveButterWordmark} alt="GiveButter case study" />
                </div>
                <p className="description">
                  How GiveButter crushed their NPS and predicted the future with&nbsp;Canny.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/document360">
            <div className="customerItemContents document360">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage src={Document360Wordmark} alt="Document360 logo" />
                </div>
                <p className="description">
                  How Document360 uses Canny to be customer-obsessed and close new&nbsp;business.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/akiflow">
            <div className="customerItemContents akiflow">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage src={AkiflowWordmark} alt="Akiflow logo" />
                </div>
                <p className="description">
                  How Akiflow organized their feedback and started winning back
                  churned&nbsp;customers.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/pallyy">
            <div className="customerItemContents pallyy">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage src={PallyyWordmark} alt="Pallyy logo" />
                </div>
                <p className="description">
                  How Canny helps Pallyy save time and shape their&nbsp;roadmap.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem double hive" to="/case-studies/hive">
            <div className="customerItemContents hive">
              <div className="text">
                <div className="top">
                  <div className="wordmark">
                    <LazyLoadedImage loading="eager" src={HiveWordmark} alt="Hive logo" />
                  </div>
                  <p className="description">
                    How Hive uses Canny to collaborate across departments and increase
                    their&nbsp;NPS.
                  </p>
                </div>
                <UppercaseHeader>
                  Read their story <span className="icon-chevron-right" />
                </UppercaseHeader>
              </div>
              <LazyLoadedImage
                className="profile"
                loading="eager"
                src={KelleyMichaela}
                alt="Michaela Rollings and Kelley Bunge"
              />
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/outlier">
            <div className="customerItemContents outlier">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage src={OutlierWordmark} alt="Outlier case study" />
                </div>
                <p className="description">
                  How Outlier scored big with product-led growth and community&nbsp;engagement.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/tldv">
            <div className="customerItemContents tldv">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage loading="eager" src={TLDVWordmark} alt="tl;dv logo" />
                </div>
                <p className="description">
                  How tl&#59;dv uses Canny to transform customer feedback into product innovation.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
          <Link className="customerItem double spekit" to="/case-studies/spekit">
            <div className="customerItemContents spekit">
              <div className="text">
                <div className="top">
                  <div className="wordmark">
                    <LazyLoadedImage loading="eager" src={SpekitWordmark} alt="Spekit logo" />
                  </div>
                  <p className="description">
                    How Spekit uses Canny to make data-backed product decisions.
                  </p>
                </div>
                <UppercaseHeader>
                  Read their story <span className="icon-chevron-right" />
                </UppercaseHeader>
              </div>
              <LazyLoadedImage
                className="profile"
                loading="eager"
                src={AndreaPark}
                alt="Andrea Park"
              />
            </div>
          </Link>
          <Link className="customerItem double appcues" to="/case-studies/appcues">
            <div className="customerItemContents appcues">
              <div className="text">
                <div className="top">
                  <div className="wordmark">
                    <LazyLoadedImage loading="eager" src={AppcuesWordmark} alt="Appcues logo" />
                  </div>
                  <p className="description">
                    How Appcues closes the feedback loop with Canny to improve their product and
                    customer experience
                  </p>
                </div>
                <UppercaseHeader>
                  Read their story <span className="icon-chevron-right" />
                </UppercaseHeader>
              </div>
              <LazyLoadedImage
                className="profile"
                loading="eager"
                src={LylaJoey}
                alt="Lyla and Joey"
              />
            </div>
          </Link>
          <Link className="customerItem" to="/case-studies/getimgai">
            <div className="customerItemContents getimgai">
              <div className="top">
                <div className="wordmark">
                  <LazyLoadedImage loading="eager" src={GetimgAIWordmark} alt="Getimg.ai logo" />
                </div>
                <p className="description">
                  How getimg.ai prioritizes feature development using Canny&apos;s feedback boards
                  and user voting system.
                </p>
              </div>
              <UppercaseHeader>
                Read their story <span className="icon-chevron-right" />
              </UppercaseHeader>
            </div>
          </Link>
        </div>
        <LandingFooterCTA style="solid" expanded={true} />
      </div>
    </div>
  );
};
export default CaseStudiesLanding;
